export default __webpack_public_path__ + "images/258061022691910ecaf6c9c1936b987a.svg";